import { GoGuidesController } from './goguides-controllers';
export var controllers = [GoGuidesController];